<template lang="pug">
    div#failedCamp-modal.tw-fixed.tw-top-0.tw-animate-fade-in.tw-left-0.tw-right-0.tw-h-modal.tw-h-full.tw-w-full(style="z-index: 99999" tabindex='-1', class='md:inset-0 md:h-full' )
        div(class="tw-bg-[#fff] tw-w-full tw-h-full tw-flex tw-justify-center tw-items-center")
            div(class="tw-w-[40%] ")
                img.w-100(src="/Icons_SVG/success_loader.svg")
                div.tw-flex.tw-justify-center.tw-mt-3 
                    div.tw-cursor-pointer.tw-w-28.tw-text-center.tw-py-2.tw-px-3.text-white.tw-bg-primary_brand.tw-rounded-md.tw-border-primary_brand(class="tw-border-[1.5px]" @click="closeWindow") 
                        i(class="fa fa-solid fa-xmark tw-mr-2 ") 
                        span Close
            
        
</template>
<script>
export default {
  data() {
    return {
      connectAccountPopup: "",
    };
  },

  mounted() {},

  methods: {
    closeWindow() {
      window.location.href =
        "https://sense.weavr.online/#/connect-your-account";
      window.close();
    },
  },
};
</script>
